export default {
      id: "mobile-number-white-usage",
      viewBox: "0 0 32 33",
      url: __webpack_public_path__ + "sprite.svg#mobile-number-white",
      toString: function () {
        return this.url;
      }
    }